import { useQuery } from '@apollo/client'
import {
  type AttendanceToleranceSettingFragment,
  GetAttendanceToleranceSettingsDocument,
  GetAttendanceToleranceSettingsQuery,
} from 'generated/resources/graphql'

export type ToleranceSetting =
  GetAttendanceToleranceSettingsQuery['attendance']['toleranceSettings'][number]

export type ToleranceSettingFragment = AttendanceToleranceSettingFragment

export const useToleranceSettings = (employeesSettingId: string) => {
  const { loading, data } = useQuery(GetAttendanceToleranceSettingsDocument, {
    variables: {
      attendanceEmployeesSettingId: employeesSettingId,
    },
  })

  return {
    loading,
    toleranceSettings: data ? data.attendance.toleranceSettings : [],
  }
}
